import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { LoadingSpinnerBorderComponent } from '../../../shared/components/loading/loading-spinner-border/loading-spinner-border.component';
import { SchemaService } from '../../../shared/services/schema.service';
import { SetAssistedAccessDto } from '../../../shared/models/schema.model';


@Component({
    selector: 'assisted-access-dialog',
    imports: [CommonModule, TranslocoDirective, ReactiveFormsModule, LoadingSpinnerBorderComponent],
    templateUrl: './assisted-access-dialog.component.html',
    styleUrl: './assisted-access-dialog.component.scss'
})
export class AssistedAccessDialogComponent {
    private fb = inject(FormBuilder);

    constructor(
        private readonly schemaService: SchemaService,
        private readonly router: Router,
        private readonly translocoService: TranslocoService
    ) { }

    @Input() schemaId: number | undefined;

    assistedAccessForm!: FormGroup;
    onConfirming: boolean = false;
    isLoading: boolean = false;
    hasError: boolean = false;
    errorText: string = "";
    submission: SetAssistedAccessDto | undefined = undefined

    ngOnInit(): void {
        this.assistedAccessForm = this.fb.group({
            cprNumber: new FormControl(''),
        });
    }

    onConfirm(): void {
        this.isLoading = true;

        if(this.schemaId == undefined){
            return;
        }

        this.submission =
        {
            schemaId: this.schemaId,
            assistedCpr: this.assistedAccessForm.get('cprNumber')?.value
        }

        this.schemaService.postSetAssistedCprInProgress(this.submission).subscribe({
            next: (result) => {
                if(result){
                    window.location.reload();
                }
                else{
                    alert(this.translocoService.translateObject('schema.othersaccess.incorrectcpr'));
                }
            },
            error: () => {
                alert(this.translocoService.translateObject('schema.othersaccess.noaccess'));
            },
            complete: () => {
                this.isLoading = false;
            }
        });
    }

    resetInputs(): void {
        this.assistedAccessForm.reset();
        this.hasError = false;
        this.errorText = "";
        this.router.navigate(['/schemas']);
    }
}
